import { terms as t, periodKeys as key } from '.';
import { agentProductionTerms as apt } from '../../constants';

export const marketDynamicsColumns = Object.freeze({
    address: {id: 'address', label: apt.address },
    areaId: {id: 'areaId', label: apt.area },
    avgCdom: { id: 'avgCdom', label: t.avgCdom, keyField: 'ucAvgCdom' },
    avgDom: { id: 'avgDom', label: t.avgDom, keyField: 'ucAvgDom' },
    avgSpOp: { id: 'avgSpOp', label: t.avgSpOp, keyField: 'spOpRatioAllProperties' },
    bankStatus: {id: 'bankStatus', label: apt.bankProperty },
    fullBaths: { id: 'fullBaths', label: apt.ba },
    bedrooms: { id: 'bedrooms', label: apt.bd },
    beginPeriod: { id: 'beginPeriod', field: key.beginPeriodValue },
    cdom: {id: 'cdom', label: apt.cdom },
    changeAvg: { id: 'changeAvg', label: t.medianPriceChange },
    changeAvgPercentage: { id: 'changeAvgPercentage', label: t.changePct },
    changeValue: { id: 'changeValue', label: t.change$ },
    changeValuePercentage: { id: 'changeValuePercentage', label: t.changePct },
    city: { id: 'city', label: apt.city },
    costPerSqft: { id: 'costPerSqft', label: t.pricePerSqft },
    dom: {id: 'dom', label: apt.dom },
    endPeriod: { id: 'endPeriod', field: key.endPeriodValue },
    expAvgDom: { id: 'expAvgDom', label: t.expAvgDom },
    expAvgPricePerSqft: { id: 'expAvgPricePerSqft', label: t.expAvgPricePerSqft },
    expAvgSqft: { id: 'expAvgSqft', label: t.expAvgSqft },
    expAvgVolume: { id: 'expAvgVolume', label: t.expAvgVolume },
    expMedianVolume: { id: 'expMedianVolume', label: t.expMedianVolume },
    expUnits: { id: 'expUnits', label: t.expUnits },
    forSaleAvgDom: { id: 'forSaleAvgDom', label: t.forSaleAvgDom },
    forSaleAvgPricePerSqft: { id: 'forSaleAvgPricePerSqft', label: t.forSaleAvgPricePerSqft },
    forSaleAvgSqft: { id: 'forSaleAvgSqft', label: t.forSaleAvgSqft },
    forSaleAvgVolume: { id: 'forSaleAvgVolume', label: t.forSaleAvgVolume },
    forSaleLastDayChangeVolume: { id: 'forSaleLastDayChangeVolume', label: t.forSaleLastDayChangeVolume },
    forSaleLastDayPercentage: { id: 'forSaleLastDayPercentage', label: t.percentDifference },
    forSaleLastDayUnits: { id: 'forSaleLastDayUnits', label: t.forSaleLastDayUnits },
    forSaleLastDayUnits0to90: { id: 'forSaleLastDayUnits0to90', label: t.units0To90Cdom },
    forSaleLastDayUnits0to90Pct: { id: 'forSaleLastDayUnits0to90Pct', label: t.units0To90CdomPct },
    forSaleLastDayUnits91to180: { id: 'forSaleLastDayUnits91to180', label: t.units91To180Cdom },
    forSaleLastDayUnits91to180Pct: { id: 'forSaleLastDayUnits91to180Pct', label: t.units91To180CdomPct },
    forSaleLastDayUnitsOver180: { id: 'forSaleLastDayUnitsOver180', label: t.unitsOver180Cdom },
    forSaleLastDayUnitsOver180Pct: { id: 'forSaleLastDayUnitsOver180Pct', label: t.unitsOver180CdomPct },
    forSaleMedianVolume: { id: 'forSaleMedianVolume', label: t.forSaleMedianVolume },
    forSaleUnits: { id: 'forSaleUnits', label: t.forSaleUnits },
    lastWeeksAvg: { id: 'lastWeeksAvg', label: t.lastWeeksAvg },
    listAgent: { id: 'listAgent', label: apt.listAgent },
    listDate: { id: 'listDate', label: apt.listDate, keyField: 'date' },
    listPrice: { id: 'listPrice', label: apt.listPrice },
    lotSizeSquareFt: { id: 'lotSizeSquareFt', label: apt.lotSizeSqft },
    mlsNum: {id: 'mlsNum', label: apt.mlsNum },
    newAvgPricePerSqft: { id: 'newAvgPricePerSqft', label: t.newAvgPricePerSqft },
    newAvgSqft: { id: 'newAvgSqft', label: t.newAvgSqft },
    newAvgVolume: { id: 'newAvgVolume', label: t.newAvgVolume },
    newMedianVolume: { id: 'newMedianVolume', label: t.newMedianVolume },
    newUnits: { id: 'newUnits', label: t.newUnits },
    officeId: { id: 'officeId', label: apt.officeId },
    officeName: { id: 'officeName', label: apt.office },
    offMarketDate: { id: 'offMarketDate', label: t.offMarketDate, keyField: 'date' },
    orgPrice: { id: 'orgPrice', label: t.orgPrice },
    periodChange: { id: 'periodChange' },
    periodChangeVolume: { id: 'periodChangeVolume' },
    periodPercentChange: { id: 'periodPercentChange' },
    periodPercentChangeUnits: { id: 'periodPercentChangeUnits' },
    previousWeeksAvg: { id: 'previousWeeksAvg', label: t.previousWeeksAvg },
    price: { id: 'price', label: t.price },
    priceChangeCnt: { id: 'priceChangeCnt', label: apt.priceChangeCnt },
    soldAvgDom: { id: 'soldAvgDom', label: t.soldAvgDom },
    soldAvgDomWithoutPriceChanges: { id: 'soldAvgDomWithoutPriceChanges', label: t.soldAvgDomWithoutPriceChanges },
    soldAvgDomWithPriceChanges: { id: 'soldAvgDomWithPriceChanges', label: t.soldAvgDomWithPriceChanges },
    soldAvgPricePerSqft: { id: 'soldAvgPricePerSqft', label: t.soldAvgPricePerSqft },
    soldAvgSqft: { id: 'soldAvgSqft', label: t.soldAvgSqft },
    soldAvgVolume: { id: 'soldAvgVolume', label: t.soldAvgVolume },
    soldChangeVolume: { id: 'soldChangeVolume', label: t.soldChangeVolume },
    soldDate: { id: 'soldDate', label: apt.soldDate, keyField: 'date' },
    soldGrowthVolumePct: { id: 'soldGrowthVolumePct', label: t.soldGrowthVolumePct },
    soldMedianVolume: { id: 'soldMedianVolume', label: t.soldMedianVolume },
    soldMsi: { id: 'soldMsi', label: t.msiSold },
    soldPrice: { id: 'soldPrice', label: apt.soldPrice, keyField: 'price' },
    soldToForSaleUnitsPct: { id: 'soldToForSaleUnitsPct', label: t.soldPercentage },
    soldUnits: { id: 'soldUnits', label: t.soldUnits },
    soldUnits0to90: { id: 'soldUnits0to90', label: t.units0To90Cdom },
    soldUnits0to90Pct: { id: 'soldUnits0to90Pct', label: t.units0To90CdomPct },
    soldUnits91to180: { id: 'soldUnits91to180', label: t.units91To180Cdom },
    soldUnits91to180Pct: { id: 'soldUnits91to180Pct', label: t.units91To180CdomPct },
    soldUnitsOver180: { id: 'soldUnitsOver180', label: t.unitsOver180Cdom },
    soldUnitsOver180Pct: { id: 'soldUnitsOver180Pct', label: t.unitsOver180CdomPct },
    soldUnitsWithoutPriceChanges: { id: 'soldUnitsWithoutPriceChanges', label: t.soldUnitsWithoutPriceChanges },
    soldUnitsWithPriceChanges: { id: 'soldUnitsWithPriceChanges', label: t.soldUnitsWithPriceChanges },
    spLpRatioWithoutPriceChanges: { id: 'spLpRatioWithoutPriceChanges', label: t.spLpRatioWithoutPriceChanges },
    spLpRatioWithPriceChanges: { id: 'spLpRatioWithPriceChanges', label: t.spLpRatioWithPriceChanges },
    spOpRatioWithoutPriceChanges: { id: 'spOpRatioWithoutPriceChanges', label: t.spOpRatioWithoutPriceChanges },
    spOpRatioWithPriceChanges: { id: 'spOpRatioWithPriceChanges', label: t.spOpRatioWithPriceChanges },
    squareFt: { id: 'squareFt', label: apt.sqft },
    status: { id: 'status', label: t.status },
    streetName: { id: 'streetName', label: apt.address },
    timePeriodStart: { id: 'timePeriodStart' },
    totalChange: { id: 'totalChange', label: t.totalChange },
    totalChangeUnits: { id: 'totalChangeUnits' },
    totalPercentChange: { id: 'totalPercentChange', label: t.totalPercentChange },
    totalPercentChangeUnits: { id: 'totalPercentChangeUnits' },
    typeName: {id: 'typeName', label: apt.type },
    ucAvgCdom: { id: 'ucAvgCdom', label: t.avgCdom },
    ucAvgDom: { id: 'ucAvgDom', label: t.ucAvgDom },
    ucAvgPricePerSqft: { id: 'ucAvgPricePerSqft', label: t.ucAvgPricePerSqft },
    ucAvgSqft: { id: 'ucAvgSqft', label: t.ucAvgSqft },
    ucAvgVolume: { id: 'ucAvgVolume', label: t.ucAvgVolume },
    ucDate: { id: 'ucDate', label: apt.ucDate, keyField: 'date' },
    ucMedianVolume: { id: 'ucMedianVolume', label: t.ucMedianVolume },
    ucMsi: { id: 'ucMsi', label: t.underContractMsi },
    ucToForSaleUnitsPct: { id: 'ucToForSaleUnitsPct', label: t.ucPercentage },
    ucUnits: { id: 'ucUnits', label: t.ucUnits },
    ucUnits0to90: { id: 'ucUnits0to90', label: t.units0To90Cdom },
    ucUnits0to90Pct: { id: 'ucUnits0to90Pct', label: t.units0To90CdomPct },
    ucUnits91to180: { id: 'ucUnits91to180', label: t.units91To180Cdom },
    ucUnits91to180Pct: { id: 'ucUnits91to180Pct', label: t.units91To180CdomPct },
    ucUnitsOver180: { id: 'ucUnitsOver180', label: t.unitsOver180Cdom },
    ucUnitsOver180Pct: { id: 'ucUnitsOver180Pct', label: t.unitsOver180CdomPct },
    yearBuilt: { id: 'yearBuilt', label: apt.yearBuilt },
    zipcode: {id: 'zipcode', label: apt.zip },
    zipCode: { id: 'zipCode', label: apt.zip },
    periodChangePercent: { id: 'periodChangePercent' },
    periodPercentChangePercent: { id: 'periodPercentChangePercent' },
    totalChangePercent: { id: 'totalChangePercent', label: t.totalChange },
    totalPercentChangePercent: { id: 'totalPercentChangePercent', label: t.totalPercentChange },
});
